(() => {
  const domReady = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  const revealObserver = typeof IntersectionObserver === 'undefined'
    ? null
    : new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  const initReveal = (root = document) => {
    root.querySelectorAll('[data-reveal]').forEach((element) => {
      if (element.dataset.revealBound === 'true') return;
      element.dataset.revealBound = 'true';
      if (!revealObserver) {
        element.classList.add('is-revealed');
        return;
      }
      revealObserver.observe(element);
    });
  };

  const initHeaderMenu = (root = document) => {
    root.querySelectorAll('[data-b2c-menu-toggle]').forEach((toggle) => {
      if (toggle.dataset.menuBound === 'true') return;
      toggle.dataset.menuBound = 'true';
      const menu = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!menu) return;
      const closeMenu = () => {
        toggle.setAttribute('aria-expanded', 'false');
        menu.classList.remove('is-open');
      };
      toggle.addEventListener('click', () => {
        const isOpen = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!isOpen));
        menu.classList.toggle('is-open', !isOpen);
      });
      menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
      document.addEventListener('click', (event) => {
        if (!menu.classList.contains('is-open')) return;
        if (menu.contains(event.target) || toggle.contains(event.target)) return;
        closeMenu();
      });
      window.addEventListener('resize', () => {
        if (window.innerWidth >= 990) closeMenu();
      });
    });
  };

  const initHeaderMood = () => {
    const onScroll = () => {
      document.body.classList.toggle('header-condensed', window.scrollY > 28);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  };

  const nextPaginationLink = (scope) => {
    const pagination = scope.querySelector('.pagination-wrapper');
    if (!pagination) return null;
    return pagination.querySelector('a[aria-label="Next"]') || pagination.querySelector('a[aria-label="next"]') || pagination.querySelectorAll('.pagination__item-arrow')[1] || null;
  };

  const initInfiniteCollection = (root = document) => {
    const container = root.querySelector('#ProductGridContainer');
    if (!container || container.dataset.infiniteReady === 'true') return;
    const grid = container.querySelector('#product-grid');
    const pagination = container.querySelector('.pagination-wrapper');
    const initialLink = nextPaginationLink(container);
    if (!grid || !pagination || !initialLink) return;
    container.dataset.infiniteReady = 'true';
    document.body.classList.add('gw-infinite-ready');
    const sentinel = document.createElement('div');
    sentinel.className = 'gw-infinite-sentinel';
    sentinel.setAttribute('aria-hidden', 'true');
    container.after(sentinel);
    let nextUrl = initialLink.href;
    let isLoading = false;
    let observer;

    const syncPagination = (nextContainer) => {
      const nextWrapper = nextContainer.querySelector('.pagination-wrapper');
      if (nextWrapper) {
        pagination.innerHTML = nextWrapper.innerHTML;
        const upcoming = nextPaginationLink(nextContainer);
        nextUrl = upcoming ? upcoming.href : '';
      } else {
        pagination.remove();
        nextUrl = '';
      }
    };

    const appendProducts = (nextContainer) => {
      const nextGrid = nextContainer.querySelector('#product-grid');
      if (!nextGrid) return false;
      const children = [...nextGrid.children];
      children.forEach((item) => {
        item.setAttribute('data-reveal', '');
        item.classList.remove('is-revealed');
        grid.appendChild(item);
      });
      initReveal(grid);
      return children.length > 0;
    };

    const loadNext = async () => {
      if (isLoading || !nextUrl) return;
      isLoading = true;
      container.classList.add('is-loading-more');
      try {
        const response = await fetch(nextUrl, { credentials: 'same-origin' });
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const nextContainer = doc.getElementById('ProductGridContainer');
        if (!nextContainer) {
          nextUrl = '';
          return;
        }
        appendProducts(nextContainer);
        syncPagination(nextContainer);
        if (!nextUrl && observer) {
          observer.disconnect();
          sentinel.remove();
        }
      } catch (error) {
        console.error('Infinite collection load failed', error);
      } finally {
        container.classList.remove('is-loading-more');
        isLoading = false;
      }
    };

    if (typeof IntersectionObserver !== 'undefined') {
      observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) loadNext();
      }, { rootMargin: '320px 0px' });
      observer.observe(sentinel);
    }
  };

  let mutationFrame = null;
  const queueRefresh = () => {
    if (mutationFrame) return;
    mutationFrame = window.requestAnimationFrame(() => {
      mutationFrame = null;
      initReveal();
      initHeaderMenu();
      initInfiniteCollection();
    });
  };

  domReady(() => {
    initReveal();
    initHeaderMenu();
    initHeaderMood();
    initInfiniteCollection();
    if (document.body) new MutationObserver(queueRefresh).observe(document.body, { childList: true, subtree: true });
  });
})();
